import { IconProps, TextProps } from '@bonanza-social/moonlight';

export type FooterLink = {
  labelKey: Required<TextProps>['locKey'];
  link?: string;
  navigateTo?: string;
  miscPath?: string;
};

export type SocialLink = {
  icon: IconProps['name'];
  link: string;
};

export const FOOTER_LINKS: FooterLink[] = [
  {
    labelKey: 'footerLink_AboutUs',
    miscPath: '/about',
  },
  {
    labelKey: 'footerLink_LevelUp',
    miscPath: '/level-up',
  },
  {
    labelKey: 'footerLink_Status',
    miscPath: '/status',
  },
  {
    labelKey: 'footerLink_PrivacyPolicy',
    miscPath: '/privacy',
  },
  {
    labelKey: 'footerLink_TermsOfUse',
    miscPath: '/terms',
  },
  {
    labelKey: 'footerLink_ContactUs',
    navigateTo: 'ContactUsScreen',
  },
];
